<template>
  <v-avatar
    :size=size
    style="background-color: #C7DCF0;"
  >
    <span
      class="black--text headline"
      style="font-size: 16px !important; line-height: 24px; color: #1D428A !important;"
    >
      {{getInitials()}}
    </span>
  </v-avatar>
</template>

<script>
  export default {
    name: "InitialsIcon",
    props: {
      givenName: {
        type: String,
        default: '',
      },
      surname: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: "40px",
      },
    },
    methods: {
      getInitials() {
        const str = this.givenName + " " + this.surname;
        return str.split(" ").map(el => el.charAt(0).toLocaleUpperCase()).join("");
      }
    },
  }
</script>

<style scoped>

</style>
